 <template>
 
 <div class="container">
    <div class="spinner"></div>
    <div class="message">{{informationMessage}}</div>
  </div>

  
</template>
  
<script setup>

  const props = defineProps({
    informationMessage: String
  })

  
</script>


<style scoped>

    .spinner {
      margin: 50px auto;
      width: 60px;
      height: 60px;
      border: 8px solid #ccc;
      border-top: 8px solid rgb(255, 90, 80); /* Updated spinner color */
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    .message {
      font-size: 1.8rem;
      font-weight: 500;
      margin-top: 20px;
      text-align: center;
    }

</style>
  